import { Sexo } from "../enums/sexo";
import { Usuario } from './usuario';

export class Vendedor {
  id:  number | null = null;
  ativo?: boolean | null = true;
  nome: string = '';
  cpf: string | null = null;
  rgIE: string = '';
  endereco: string = '';
  numero: string = '';
  bairro: string = '';
  cep: string = '';
  cidade: string = '';
  estado: string = '';
  telefone: string = '';
  celular: string = '';
  email: string = '';
  contato: string = '';
  sexo: Sexo | null = null;
  usuario: Usuario | null = null;
  // campo opcional para representar usuarioId enviado pelo backend (VendedorDto.usuarioId)
  usuarioId?: number | null = null;
  dataCadastro: string = '';
  dataUltimaModificacao: string | null = null;
}
